import styled from 'styled-components/macro';


const FormDiv = styled.div`
    flex: 4;
`

export default FormDiv